import React from 'react';
import { Route, Switch } from 'react-router';
import ViewTaskTypes from './view';
import EditTaskTypes from './edit';
import CreateTaskTypes from './create';

const TaskTypes = () => {
  return (
    <Switch>
      <Route exact path='/admin/task-types' component={ViewTaskTypes} />
      <Route exact path='/admin/task-types/new' component={CreateTaskTypes} />
      <Route exact path='/admin/task-types/:id' component={EditTaskTypes} />
    </Switch>
  );
};

export default TaskTypes;
